import { types } from './webhookPixPagamento.actions'
import { Reducer } from '../../services/reducer.factory'
import storage from '../../services/stoage.service'

const initialState = {
  id: 'webhookpixpagamento',
  selectedFilters: [],
  showHideColumns: [
    {
      label: 'Código',
      value: {
        field: 'oid',
        header: 'Código',
        columnKey: 'oid',
        sortable: true,
        columnSortField: 'oid',
        filter: true,
        visible: true,
      },
    },
    {
      label: 'Descrição',
      value: {
        field: 'descricao',
        header: 'Descrição',
        columnKey: 'descricao',
        sortable: true,
        columnSortField: 'descricao',
        filter: true,
        visible: true,
      },
    },
    {
      label: 'Identificador',
      value: {
        field: 'identificador',
        header: 'Identificador',
        columnKey: 'identificador',
        sortable: true,
        columnSortField: 'identificador',
        filter: true,
        visible: true,
      },
    },
  ],
  columnsLookup: [
    {
      field: 'oid',
      header: 'Código',
      columnKey: 'oid',
      sortable: true,
      columnSortField: 'oid',
      filter: true,
      visible: true,
    },
    {
      field: 'descricao',
      header: 'Descrição',
      columnKey: 'descricao',
      sortable: true,
      columnSortField: 'descricao',
      filter: true,
      visible: true,
    },
  ],

  columns: [],
  currentRecord: {
    oid: '',
    descricao: '',
    identificador: '',
    ativo: true,
  },
  messages: null,
  usaListDto: false,
}

const reducer = new Reducer(initialState, types)

export function CRUDWebhookPixPagamentoReducer(state, action) {
  if (state) {
    state.messages = storage.getAppLabels('webhookpixpagamento')
  }
  state = reducer.execute(state, action)
  return execute(state, action)
}

function execute(state, action) {
  switch (action.type) {
    case types.RESET:
      return reset(state, action)
    case types.MAKE_NEW:
      return initialize(state)
    default:
      return state
  }
}

function reset(state, action) {
  return {
    ...state,
    currentRecord: initialState.currentRecord,
    records: [],
    selectedFilters: [],
  }
}

const initialize = (state) => {
  const currentRecord = state.currentRecord
  return Object.assign({}, state, { currentRecord: currentRecord })
}
